// extracted by mini-css-extract-plugin
export var badge = "_gk-2";
export var detailsPanel = "_gk-0";
export var resultRow = "_gk-1";